/**
 * Hook for fetching application info
 */

import { useQuery } from '@tanstack/react-query';
import { appInfoApi } from '../services/appInfo.service';

export function useAppInfo() {
  return useQuery({
    queryKey: ['app-info'],
    queryFn: appInfoApi.getAppInfo,
    staleTime: 30 * 1000, // 30 seconds
  });
}